import { render } from "./CarnetClientView.vue?vue&type=template&id=556da262&scoped=true"
import script from "./CarnetClientView.vue?vue&type=script&lang=js"
export * from "./CarnetClientView.vue?vue&type=script&lang=js"

import "./CarnetClientView.vue?vue&type=style&index=0&id=556da262&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556da262"]])

export default __exports__